/* eslint jsx-a11y/label-has-associated-control: ["error", { assert: "either", depth: 25 }] */
import React, { useState, useEffect } from 'react';
// import/no-extraneous-dependencies
// import/no-extraneous-dependencies
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useCreateNewsLetterMutation, useEditNewsletterMutation } from '../../../../redux/apiSlice';
import TextAreaField from '../../../components/FormsElements/TextAreaField';
import RichTextEditor from '../../../components/FormsElements/RickTextEditor';
import FileUpload from '../../../components/FormsElements/FileUpload';
import EventButton from '../../../components/Buttons/EventButton';
import ElementSelection from '../../../components/FormsElements/ElementSelection';
import GetAllSubscribers from './GetAllSubscribers';

const NewsLetterForm = ({ newsLetterData }) => {
  const [newletterDetails, setNewsletterDetails] = useState({
    content: '',
    category: '',
    title: '',
  });

  const [editNewsletter] = useEditNewsletterMutation();
  const [createNewsLetter] = useCreateNewsLetterMutation();

  useEffect(() => {
    if (newsLetterData) {
      setNewsletterDetails({
        title: newsLetterData.title || '',
        category: newsLetterData.category || '',
        content: newsLetterData.content || '',
      });
    }
  }, [newsLetterData]);

  const [image, setImage] = useState(null);
  console.log(image);
  const [successMsg, setSuccessMsg] = useState('');
  const navigate = useNavigate();
  const [errors, setErrors] = useState({
    title: '',
    category: '',
    content: '',
  });

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    setImage(file);
  };

  const handlePublish = async (e) => {
    e.preventDefault();

    const newErrors = {};
    if (newletterDetails.title.trim() === '') {
      newErrors.title = 'Title is required';
    }
    if (newletterDetails.category.trim() === '') {
      newErrors.category = 'Category is required';
    }
    if (newletterDetails.content.trim() === '') {
      newErrors.content = 'Content is required';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({
      title: '',
      category: '',
      content: '',
    });

    const currentDate = new Date().toISOString();
    const formData = {
      title: newletterDetails.title,
      category: newletterDetails.category,
      content: newletterDetails.content,
      modified_date: currentDate,
    };

    try {
      if (newsLetterData) {
        await editNewsletter({
          newsletterId: newsLetterData.id,
          updates: formData,
        });
        setSuccessMsg('News Letter updated successfully');
      } else {
        await createNewsLetter({ ...formData });
        setSuccessMsg('News Letter added successfully');
      }
      setTimeout(() => {
        setSuccessMsg('');
        setNewsletterDetails({
          title: '',
          category: '',
          content: '',
        });
        navigate('/private/newsletter/get-all-newsletters');
      }, 2000);
    } catch (error) {
      console.error('Failed to publish newsletter', error);
    }
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setNewsletterDetails((prevDetails) => ({
      ...prevDetails,
      [id]: value,
    }));
  };

  const handleContentChange = (content) => {
    setNewsletterDetails((prevDetails) => ({
      ...prevDetails,
      content,
    }));
  };

  const handleCategoryChange = (e) => {
    const category = e.target.value;
    setNewsletterDetails((prevDetails) => ({
      ...prevDetails,
      category,
    }));
  };
  return (
    <section className="p-8 w-full text-lg flex gap-4">
      <div className="bg-private p-5 dark:bg-gray-800 relative shadow-md w-3/4 rounded">
        {successMsg && <p className="text-gray-300 xl:text-lg dark:bg-gray-700 text-center px-4 py-3 rounded relative">{successMsg}</p>}
        <h2 className="text-xl text-gray-100 font-extrabold py-4">
          {newsLetterData ? 'Edit' : 'Publish'}
          {' '}
          a NewsLetter
        </h2>
        {errors.title && <p className="text-red-500 text-sm">{errors.title}</p>}
        <TextAreaField
          label="Subject:"
          id="title"
          name="title"
          value={newletterDetails.title}
          onChange={handleInputChange}
          type="text"
          row={2}
          col={10}
        />
        {errors.category && <p className="text-red-500 text-sm">{errors.category}</p>}
        <ElementSelection
          label="Category:"
          name="category"
          value={newletterDetails.category}
          onChange={handleCategoryChange}
          options={['Select a category', 'Aviation', 'OSHE']}
        />
        <RichTextEditor
          label="Content:"
          name="content"
          value={newletterDetails.content}
          onChange={handleContentChange}
          type="text"
        />
        <FileUpload
          label="Upload Attachment:"
          name="attachment"
          onChange={handleImageUpload}
        />
        <EventButton
          onSubmit={handlePublish}
          linktext={newsLetterData ? 'Edit News letter' : 'Add news letter'}
        />
      </div>
      <div className="bg-private p-5 dark:bg-gray-800 relative shadow-md w-1/4 text-gray-100 rounded">
        <h4>Newsletter engagements</h4>
        <GetAllSubscribers />
      </div>
    </section>
  );
};

NewsLetterForm.propTypes = {
  newsLetterData: PropTypes.shape({
    title: PropTypes.string,
    category: PropTypes.string,
    content: PropTypes.string,
    id: PropTypes.number,
  }).isRequired,
};

export default NewsLetterForm;
